export { millisecondsToRelativeTime } from '@/shared/helpers/time.helper';

export { computeTargetCenter } from '@/shared/helpers/dom.helper';

export { withFormat } from '@/shared/helpers/number.helper';

export const sleep = async (ms: number) => new Promise((res) => window.setTimeout(res, ms));
